import React from 'react'
import { makeStyles } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'

import { IInputProps } from 'src/types'
import { validationErrorToString } from 'src/adminPanel/screens/inputs/validators'
import { useTranslate } from 'ra-core'

import { TAppTheme } from 'src/theme/theme'

const useStyles = makeStyles<TAppTheme>(theme => ({
  datePicker: {
    ...theme.inputs.textfield,
    margin: 0,
    padding: 0,
    marginBottom: theme.spacing(1),
  },
}))

const DateTimeInput = ({
  property,
  value,
  error,
  onChange,
  invalid,
}: IInputProps<Date>): JSX.Element => {
  const translate = useTranslate()
  const classes = useStyles()

  const inputValue = value ?? null

  return (
    <DatePicker
      fullWidth
      className={classes.datePicker}
      error={invalid}
      helperText={validationErrorToString(translate)(error)}
      value={inputValue}
      openTo='year'
      disableFuture
      format='MM/dd/yyyy'
      views={['year', 'month', 'date']}
      label={property.displayedName}
      onChange={e => {
        onChange(e.toUTCString())
      }}
    />
  )
}

export default DateTimeInput
